import {
    SET_SOURCECURRENCY,
    SET_TARGETCURRENCY,
    SET_ORDERIDS,
    SET_ORDERS,
    SET_TIME,
    SET_TOTALSOURCEAMOUNT,
    SET_TOTALCONVERTEDAMOUNT,
    SET_TOTALTARGETAMOUNT,
    SET_TOTALREMITFEES,
    SET_REMAININGTIME,
    SET_MODALVISIBLE,
    LOCKEXCHANGERATE_REQUEST,
    LOCKEXCHANGERATE_SUCCESS,
    LOCKEXCHANGERATE_FAILURE,
    UPDATEEXCHANGERATE_REQUEST,
    UPDATEEXCHANGERATE_SUCCESS,
    UPDATEEXCHANGERATE_FAILURE, UPDATEEXCHANGERATE_CLEAN_ERROR, UPDATEEXCHANGERATE_CLEAN_SUCCESS,
} from "./bulkFxUpdateType";

const initialState = {
    modalVisible: false,
    loading: false,
    orderIds: [],
    orders: [],
    sourceCurrency: null,
    targetCurrency: null,
    totalSourceAmount: 0,
    totalConvertedAmount: 0,
    totalTargetAmount: 0,
    totalRemitFees: 0,
    lockedExchangeRate: null,
    remainingTime: 10,
    time: "",
    error: "",
};
  
const bulkFxUpdateReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SOURCECURRENCY: {
            return {
                ...state,
                sourceCurrency: action.sourceCurrency,
            };
        }

        case SET_TARGETCURRENCY: {
            return {
                ...state,
                targetCurrency: action.targetCurrency,
            };
        }

        case SET_ORDERIDS: {
            return {
                ...state,
                orderIds: action.orderIds,
            };
        }

        case SET_ORDERS: {
            return {
                ...state,
                orders: action.orders,
            };
        }

        case SET_TOTALSOURCEAMOUNT: {
            return {
                ...state,
                totalSourceAmount: action.totalSourceAmount,
            };
        }

        case SET_TOTALCONVERTEDAMOUNT: {
            return {
                ...state,
                totalConvertedAmount: action.totalConvertedAmount,
            };
        }

        case SET_TOTALTARGETAMOUNT: {
            return {
                ...state,
                totalTargetAmount: action.totalTargetAmount,
            };
        }

        case SET_TOTALREMITFEES: {
            return {
                ...state,
                totalRemitFees: action.totalRemitFees,
            };
        }

        case SET_TIME: {
            return {
                ...state,
                time: action.time,
            };
        }

        case SET_REMAININGTIME: {
            return {
                ...state,
                remainingTime: action.remainingTime,
            };
        }

        case SET_MODALVISIBLE: {
            return {
                ...state,
                modalVisible: action.modalVisible,
            };
        }

        case LOCKEXCHANGERATE_REQUEST: {
            return {
                ...state,
                loading: true,
            };
        }
    
        case LOCKEXCHANGERATE_SUCCESS: {
            return {
                ...state,
                loading: false,
                lockedExchangeRate: action.payload,
                error: "",
            };
        }
    
        case LOCKEXCHANGERATE_FAILURE: {
            return {
                ...state,
                loading: false,
                lockedExchangeRate: null,
                error: action.payload,
            };
        }

        case UPDATEEXCHANGERATE_REQUEST: {
            return {
                ...state,
                loading: true,
            };
        }
    
        case UPDATEEXCHANGERATE_SUCCESS: {
            return {
                ...state,
                orders: action.payload,
                loading: false,
                error: "",
                success:"SUCCESS"
            };
        }
    
        case UPDATEEXCHANGERATE_FAILURE: {
            let result = {
                ...state,
                loading: false,
                error: action.payload,
            };
            return result;
        }

        case UPDATEEXCHANGERATE_CLEAN_ERROR: {
            let result = {
                ...state,
                loading: false,
                error: "",
            };
            return result;
        }

        case UPDATEEXCHANGERATE_CLEAN_SUCCESS: {
            let result = {
                ...state,
                loading: false,
                success: "",
            };
            return result;
        }

        default:
        return state;
    }
};

export default bulkFxUpdateReducer;
  